// extracted by mini-css-extract-plugin
module.exports = {"profile":"Profile_profile__SK58n","container":"Profile_container__u0pou","form":"Profile_form__1wa9a"};